const DISABLE_IMAGE_SYNC = true;
if (!DISABLE_IMAGE_SYNC) {
  // your existing ResizeObserver / syncImageHeight code here
}
(function () {
  function init(root) {
    if (!root) return;

    const items = Array.from(root.querySelectorAll('[data-faq-item]'));
    const moreBtn = root.querySelector('[data-faq-more]');
    const leftCol = root.querySelector('[data-faq-left]');
    const imgFrame = root.querySelector('[data-faq-image-frame]');

    const singleOpen = root.getAttribute('data-single-open') === 'true';
    const enableShowMore = root.getAttribute('data-enable-show-more') === 'true';
    const initialVisible = parseInt(root.getAttribute('data-initial-visible') || '5', 10);
    const labelMore = root.getAttribute('data-show-more-label') || 'SHOW MORE';
    const labelLess = root.getAttribute('data-show-less-label') || 'SHOW LESS';

    function closeItem(item) {
      item.classList.remove('is-open');
      const btn = item.querySelector('.cryo_faqimg__q');
      const panel = item.querySelector('.cryo_faqimg__a');
      if (!btn || !panel) return;
      btn.setAttribute('aria-expanded', 'false');
      panel.setAttribute('aria-hidden', 'true');
      panel.style.maxHeight = '0px';
    }

    function openItem(item) {
      item.classList.add('is-open');
      const btn = item.querySelector('.cryo_faqimg__q');
      const panel = item.querySelector('.cryo_faqimg__a');
      if (!btn || !panel) return;
      btn.setAttribute('aria-expanded', 'true');
      panel.setAttribute('aria-hidden', 'false');

      const inner = panel.querySelector('.cryo_faqimg__aInner');
      const target = (inner ? inner.scrollHeight : panel.scrollHeight) + 28;
      panel.style.maxHeight = target + 'px';
    }

    // Accordion click
    items.forEach((item) => {
      const btn = item.querySelector('.cryo_faqimg__q');
      const panel = item.querySelector('.cryo_faqimg__a');
      if (!btn || !panel) return;

      closeItem(item);

      btn.addEventListener('click', () => {
        const isOpen = item.classList.contains('is-open');

        if (singleOpen) {
          items.forEach((it) => {
            if (it !== item) closeItem(it);
          });
        }

        if (isOpen) closeItem(item);
        else openItem(item);

        syncImageHeight();
      });
    });

    // Show more / less
    function applyShowMore() {
      if (!enableShowMore || !moreBtn) return;

      const total = items.length;
      if (total <= initialVisible) {
        moreBtn.style.display = 'none';
        return;
      }

      // initial (show less)
      items.forEach((it, idx) => {
        if (idx >= initialVisible) it.style.display = 'none';
      });
      moreBtn.textContent = labelMore;
      moreBtn.setAttribute('data-expanded', 'false');

      moreBtn.addEventListener('click', () => {
        const expanded = moreBtn.getAttribute('data-expanded') === 'true';

        if (!expanded) {
          items.forEach((it) => (it.style.display = ''));
          moreBtn.setAttribute('data-expanded', 'true');
          moreBtn.textContent = labelLess;
        } else {
          items.forEach((it, idx) => {
            if (idx >= initialVisible) {
              closeItem(it);
              it.style.display = 'none';
            }
          });
          moreBtn.setAttribute('data-expanded', 'false');
          moreBtn.textContent = labelMore;
        }

        syncImageHeight();
      });
    }

    // Make right image proportional to left column height (desktop only)
    const mq = window.matchMedia('(min-width: 901px)');

   function syncImageHeight() {
  return; // DISABLED — keep image fixed size
}


    // Recalc on resize
    window.addEventListener('resize', () => {
      // also recalc open panel heights
      items.forEach((item) => {
        if (!item.classList.contains('is-open')) return;
        const panel = item.querySelector('.cryo_faqimg__a');
        const inner = panel ? panel.querySelector('.cryo_faqimg__aInner') : null;
        if (panel) panel.style.maxHeight = ((inner ? inner.scrollHeight : panel.scrollHeight) + 28) + 'px';
      });
      syncImageHeight();
    });

    applyShowMore();
    syncImageHeight();
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-cryo-faq]').forEach(init);
  });

  document.addEventListener('shopify:section:load', (e) => {
    const root = e.target && e.target.querySelector ? e.target.querySelector('[data-cryo-faq]') : null;
    if (root) init(root);
  });
})();
